import React from "react";
import { useContent } from "../hooks/useContent";

const DEFAULT_LOGOS = [
    "Cabinets Dentaires",
    "Centre d'Implantologie",
    "Clinique Specialisée",
    "Laboratoire Dental",
    "Dental Care Pro",
    "Centre Médico-Dentaire",
    "Studio Implantaire",
    "Cabinet Orthodontie",
    "Clinique Maxillo",
    "Lab Prothèse",
];

const TrustedBy = () => {
    const { data } = useContent("trusted_by");
    const logos = data?.data?.logos || DEFAULT_LOGOS;

    return (
        <section className="relative py-16 md:py-24 bg-[#F5F5F7] border-y border-black/[0.06]">
            <div className="max-w-[1320px] mx-auto px-6 md:px-10">
                {/* Logo marquee */}
                <div className="relative overflow-hidden no-scrollbar">
                    <div className="absolute left-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-r from-[#F5F5F7] to-transparent" />
                    <div className="absolute right-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-l from-[#F5F5F7] to-transparent" />
                    <div className="flex gap-12 dp-marquee whitespace-nowrap">
                        {[...logos, ...logos].map((l, i) => (
                            <div
                                key={i}
                                className="flex items-center gap-3 text-neutral-500 hover:text-neutral-800 transition-colors"
                            >
                                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                                    <rect
                                        x="2"
                                        y="2"
                                        width="20"
                                        height="20"
                                        rx="5"
                                        stroke="currentColor"
                                        strokeWidth="1.4"
                                    />
                                    <path
                                        d="M7 12 L11 16 L17 8"
                                        stroke="currentColor"
                                        strokeWidth="1.4"
                                    />
                                </svg>
                                <span className="font-display text-[15px] tracking-tight">
                                    {l}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TrustedBy;
